<template>
  <controller>
    <page-header title="Campanhas">
      <template #side>
        <a
          href="#"
          class="btn btn-primary"
          v-if="!novo"
          @click.prevent="newCampanha"
        >
          <span>Nova Campanha</span>
        </a>
      </template>
    </page-header>
    <main>
      <header class="searchHeader">
        <div class="frame nano fixed">
          <input-control
            search
            preventSearchButton
            v-model="query"
            placeholder="Buscar..."
          />
        </div>
      </header>

      <section>
        <campanhas
          ref="campanhas"
          :busca="query"
          @campanha-salva="voltarBotao"
          @campanha-cancelada="voltarBotao"
        />
      </section>
    </main>
  </controller>
</template>

<script>
import Campanhas from '@/components/financeiro/negocieja/campanhas/template/Campanhas.vue'

export default {
  components: { Campanhas },
  data () {
    return {
      query: '',
      novo: false
    }
  },

  methods: {
    newCampanha () {
      this.$refs.campanhas.novaCampanha() 
      this.novo = true                     
    },
    voltarBotao () {
      this.novo = false
    }
  }
}
</script>

<style lang="scss" scoped>
.searchHeader {
  width: 100%;
  padding: $hmg_mid;
  border-bottom: $border-component;
}
</style>